export const ZONE_NAME_MAX_LETTERS = 128;
export const nameValidator = (t) => (input) => {
    let err = null;
    if (!input || !input.trim().length) {
        err = t('zones.validation.zone-empty-name');
    } else if (input.trim().length > ZONE_NAME_MAX_LETTERS) {
        err = t('zones.validation.zone-name-too-long', { maxLetters: ZONE_NAME_MAX_LETTERS });
    }
    return err;
};

export const ZONE_CODE_MAX_LETTERS = 10;
const ALLOWED_ASCII_CHARS = /[\x20-\x7F]+$/;
export const codeValidator = (t) => (input) => {
    let err = null;
    if (!input || !input.trim().length) {
        err = t('zones.validation.zone-empty-code');
    } else if (input.trim().length > ZONE_CODE_MAX_LETTERS) {
        err = t('zones.validation.zone-code-too-long', { maxLetters: ZONE_CODE_MAX_LETTERS });
    } else if (!ALLOWED_ASCII_CHARS.test(input)) {
        err = t('zones.validation.zone-invalid-code');
    }
    return err;
};
